import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  currentScreenIndex: PropTypes.number,
  label: PropTypes.string
};

class BrowserContainer extends Component {
  constructor(props) {
    super(props);
    this.browserTitle = React.createRef();
  }

  componentDidMount() {
    this.browserTitle.current.focus();
  }

  render() {
    return (
      <section className='ht-full container-chrome bra-25' aria-label={`Browser Window: ${this.props.label}`}>
        <div className='df df-vert-center bdr-s brt-25 container-chrome-header'>
          <span className='mlm mrxs dib chrome-button chrome-red'></span>
          <span className='mhxs dib chrome-button chrome-yellow'></span>
          <span className='mhxs dib chrome-button chrome-green'></span>
          <h1 className='f4 horz-center no-focus-halo' tabIndex='-1' ref={this.browserTitle}>
            {this.props.label}
          </h1>
          <span className='container-chrome-spacer'></span>
        </div>
        <div className='container-chrome-body brb-25 scroll-y'>
          {this.props.children}
        </div>
      </section>
    );
  }
}

BrowserContainer.propTypes = propTypes;
export default BrowserContainer;




// WEBPACK FOOTER //
// ./src/containers/browserContainer/index.js